import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { PrimeNgModule } from './modules/prime-ng/prime-ng.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './modules/shared/shared.module';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import '@angular/compiler';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { NgImageFullscreenViewModule } from 'ng-image-fullscreen-view';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AdminModule } from './modules/admin/admin.module';
import { NavbarComponent } from './navbar/navbar.component';
import { DialogService } from 'primeng/dynamicdialog';
import { JwtModule } from '@auth0/angular-jwt';
import { AuthGuard } from './guard/guard.component';
import { PosModule } from './modules/pos/pos.module';
import { PosNavbarComponent } from './pos-navbar/pos-navbar.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { WaiterModule } from './modules/waiter/waiter.module';
import { WaiterTableComponent } from './waiter-panel/components/waiter-table/waiter-table.component';
import { AddNoteComponent } from './waiter-panel/components/waiter-table/add-note/add-note.component';
import { DisplayOrderComponent } from './waiter-panel/components/display-order/display-order.component';
import { DisplayBillsComponent } from './waiter-panel/components/display-bills/display-bills.component';
import { PaymentInfoComponent } from './waiter-panel/components/display-bills/payment-info/payment-info.component';
import { DeleteOrderBillComponent } from './waiter-panel/components/display-bills/delete-order-bill/delete-order-bill.component';
import {OrderDataTransferService} from "./waiter-panel/services/order/order-data-transfer.service";
import {ConfirmDialogModule} from "primeng/confirmdialog";
import { ApiModule } from 'src/api/generated/api.module'
import { environment } from 'src/environments/environment';
import { ApiHttpInterceptor } from './interceptors/http-interceptor.interceptor';
import { NoVenuesComponent } from './pos-panel/components/no-venues/no-venues.component';

// Http Loader for ngx-translate
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    PosNavbarComponent,
    WaiterTableComponent,
    AddNoteComponent,
    DisplayOrderComponent,
    DisplayBillsComponent,
    PaymentInfoComponent,
    DeleteOrderBillComponent,
    NoVenuesComponent,
    ],
  imports: [
    DragDropModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    InfiniteScrollModule,
    PrimeNgModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    NgImageFullscreenViewModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        deps: [HttpClient],
        useFactory: createTranslateLoader
      }
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return localStorage.getItem("pos_access_token");
        },
      },
    }),
    ApiModule.forRoot({ rootUrl: environment.apiURL }),
    AdminModule,
    PosModule,
    WaiterModule,
    ConfirmDialogModule,

  ],
  exports: [],
  providers: [DialogService, AuthGuard, OrderDataTransferService, { provide: HTTP_INTERCEPTORS, useClass: ApiHttpInterceptor, multi: true  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
